


































































































































































































































































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getIndexFromList,
    convertDictionaryToList,
    numberIsGreaterThanZero,
    isNumber
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import Input from '../../core/components/Input.vue';
import InfoIcon from '../../core/components/InfoIcon.vue';
import CreateSessionFrame from './CreateSessionFrame.vue';
import HexadecimalValue from './HexadecimalValue.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { NormsServices } from '../api/NormsServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import { ProtocolIds } from '../utils';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        PlusEyeButtons,
        InfoIcon,
        Breadcrums,
        CreateSessionFrame,
        CloseConfirmationModal,
        Input,
        HexadecimalValue
    }
})
export default class CreateProtocol extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() currentAction: string;
    @Prop() protocolTypes: any;
    @Prop() patchData: any;
    @Prop() editing: boolean;
    @Prop() editingEcu: boolean;
    visibleCloseConfirmationModal: boolean = false;
    visibleModalCreateSessionFrame: boolean = false;
    loadingModifyInicialization: boolean = false;
    loadingModifyFinalization: boolean = false;
    visibleModalCreateProtocol: boolean = false;
    errorResponse: any = {};
    actionModalInitOrFin: string = '';
    modalTitle: string = 'Crear Protocolo';
    submitButtonText: string = 'Crear Protocolo';
    msgLoadingDialog: string = '';
    successPost: boolean | null = null;
    pendingRequest: boolean = false;
    editSessionFrame: boolean = false;
    pendingProtocolInitializations: boolean = false;
    pendingProtocolFinalizations: boolean = false;
    idScannerProtocol: number = 255;
    existsEmptyFields: number = 0;
    //base data
    protocolDescription: string = '';
    baudrate: number | string = 0;
    protocolType: any | null = null;
    dynamicFormFields: any = [];
    //vmodels
    initializationSelected: any | null = null;
    resetInitializationSelect: boolean = false;
    initializationsOptions: any = [];
    finalizationSelected: any | null = null;
    resetFinalizationSelect: boolean = false;
    finalizationsOptions: any = [];
    targetAddrTypeBoolean: boolean | null = null;
    kw1: number = 0;
    kw2: number = 0;
    p1max: number = 0;
    p2max: number = 0;
    p3min: number = 0;
    p3max: number = 0;
    p4min: number = 0;
    crctype: number = 0;
    p2can: number = 0;
    p2canextended: number = 0;
    framesize: number = 0;
    nbrmin: number = 0;
    nbsmax: number = 0;
    ncrmax: number = 0;
    ncsmin: number = 0;
    phaseseg1: number = 1;
    phaseseg2: number = 1;
    propseg: number = 1;
    sjw: number = 1;
    requesttimeout: number = 0;
    keepaliveinterval: number = 0;
    timesync: number = 0;
    timeidle: number = 0;
    timeinterbyterequest: number = 0;
    sourceidposition: number = 0;
    msgvalidationtype: number | null = null;
    msgdetectiontype: number | null = null;
    extravar1: number = 0;
    extravar2: number = 0;
    extravar3: number = 0;
    headertype: number = 0;
    headerfilter: number = 0;
    headermask: string = '';
    idposition: number = 0;
    idlenght: number = 0;
    keepalivetimeout: number = 0;
    extrabuffer: string = '';
    addrfilter: string = '';
    addrmask: string = '';

    //combobox fields
    addrformat: object | null = null;
    addrFormatOptions: Array<object> = [];

    addrfiltertype: object | null = null;
    addrFilterTypeOptions: Array<object> = [];
    headerTypeOptions: Array<object> = [];


    targetAddrType: object | null = null;
    targetAddrTypeOptions: Array<object> = [];


    sample3times: boolean | null = null;

    booleanOptions: any = [
        {
            value: true,
            description: 'true'
        },
        {
            value: false,
            description: 'false'
        }
    ];
    rxMsgValidationTypeOptions:Array<object> = [
        {
            value: 0,
            description: '0-None'
        },
        {
            value: 1,
            description: '1- Sum'
        },
        {
            value: 2,
            description: '2-SumMinus0x84'
        },
        {
            value: 3,
            description: '3-CRC16 (Init = 0, X16+x15+x2+1)'
        },
        {
            value: 4,
            description: '4-NMEA Checksum'
        }
    ];

    rxMsgDetectionTypeOptions:Array<object> = [
        {
            value: 0,
            description: '0-None'
        },
        {
            value: 1,
            description: '1-TimeOutOnly'
        },
        {
            value: 2,
            description: '2-TimeOutOrLength'
        },
        {
            value: 3,
            description: '3-TimeOutOrFinalBytes'
        },
        {
            value: 4,
            description: '4-HeaderAndLength'
        },
        {
            value: 5,
            description: '5-HeaderAndLengthPlus1'
        },
        {
            value: 6,
            description: '6-HeaderAndLengthPlus2'
        }
    ]

    //protocols ids
    //ISO14230 > 0
    //ISO15765 > 1
    //J1939 > 2
    //J1587 > 4
    //SERIAL > 5
    //CAN > 6
    //Scanner > 255
    fields: any = [
        {
            label: 'SourceIdPosition',
            key: 'sourceidposition',
            tooltip: '',
            type: 'number',
            protocol_id: [5],
            required: true,
            model: this.sourceidposition
        },
        {
            label: 'KeepAliveInterval',
            key: 'keepaliveinterval',
            tooltip: '',
            type: 'number',
            protocol_id: [2, 5],
            required: true,
            model: this.keepaliveinterval
        },
        {
            label: 'TimeInterByteRequest',
            key: 'timeinterbyterequest',
            type: 'number',
            tooltip: '',
            protocol_id: [4, 5],
            required: true,
            model: this.timeinterbyterequest
        },
        {
            label: 'RxMsgValidationType',
            key: 'msgvalidationtype',
            type: 'select',
            options: this.rxMsgValidationTypeOptions,
            trackBy: 'value',
            tooltip: '',
            value: 'description',
            noOptionsText: '',
            protocol_id: [5],
            required: true,
            model: this.msgvalidationtype
        },
        {
            label: 'RxMsgDetectionType',
            key: 'msgdetectiontype',
            type: 'select',
            options: this.rxMsgDetectionTypeOptions,
            trackBy: 'value',
            tooltip: '',
            value: 'description',
            protocol_id: [5],
            required: true,
            model: this.msgdetectiontype
        },
        {
            label: 'ExtraVar1',
            key: 'extravar1',
            tooltip: `Si RxMsgDetectionType = 0 -> Sin uso <br> Si RxMsgDetectionType = 1, 2, 3 -> TimeOut en ms <br>Si RxMsgDetectionType = 4, 5, 6 -> InitPosition Length en la Trama`,
            type: 'number',
            protocol_id: [5],
            required: true,
            model: this.extravar1
        },
        {
            label: 'ExtraVar2',
            key: 'extravar2',
            tooltip: `Si RxMsgDetectionType = 0, 1 -> Sin uso <br> Si RxMsgDetectionType = 2 -> InitPosition del Length en Trama (>=0) <br> Si RxMsgDetectionType = 3 -> Cantidad de Bytes del ExtraBuffer <br> Si RxMsgDetectionType = 4, 5, 6 -> Cnt de Bytes del Length en Trama`,
            type: 'number',
            protocol_id: [5],
            required: true,
            model: this.extravar2
        },
        {
            label: 'ExtraVar3',
            key: 'extravar3',
            tooltip: `Si RxMsgDetectionType = 0, 1, 3 -> Sin uso <br> Si RxMsgDetectionType = 2 -> Cnt de Bytes del Length en la Trama <br> Si RxMsgDetectionType = 4, 5, 6 -> Cantidad de Bytes del ExtraBuffer`,
            type: 'number',
            protocol_id: [5],
            required: true,
            model: this.extravar3
        },
        {
            label: 'ExtraBuffer',
            key: 'extrabuffer',
            tooltip: `Si RxMsgDetectionType = 0, 1, 2 -> Sin uso <br> Si RxMsgDetectionType = 3 -> Almacena los Bytes finales <br> Si RxMsgDetectionType = 4, 5, 6 -> Almacena los Bytes del Header a recibir`,
            type: 'text',
            maxLength: 50,
            protocol_id: [5],
            required: true,
            model: this.extrabuffer
        },
        {
            label: 'P2CANExtended',
            key: 'p2canextended',
            tooltip: '',
            type: 'number',
            protocol_id: [1],
            required: true,
            model: this.p2canextended
        },
        {
            label: 'KW1',
            key: 'keyword1',
            type: 'number',
            tooltip: '',
            protocol_id: [0],
            required: true,
            model: this.kw1
        },
        {
            label: 'KW2',
            key: 'keyword2',
            tooltip: '',
            type: 'number',
            protocol_id: [0],
            required: true,
            model: this.kw2
        },
        {
            label: 'P1max',
            key: 'p1max',
            type: 'number',
            tooltip: '',
            protocol_id: [0],
            required: true,
            model: this.p1max
        },
        {
            label: 'P2max',
            key: 'p2max',
            type: 'number',
            tooltip: '',
            protocol_id: [0],
            required: true,
            model: this.p2max
        },
        {
            label: 'P3min',
            key: 'p3min',
            type: 'number',
            tooltip: '',
            protocol_id: [0],
            required: true,
            model: this.p3min
        },
        {
            label: 'AddrFormat',
            key: 'addrformat',
            tooltip: '',
            type: 'select',
            options: this.addrFormatOptions,
            trackBy: 'id',
            value: 'value',
            noOptionsText: '',
            protocol_id: [1],
            required: true,
            model: ''
        },
        {
            label: 'P4min',
            key: 'p4min',
            type: 'number',
            tooltip: '',
            protocol_id: [0],
            required: true,
            model: this.p4min
        },
        {
            label: 'CRCType',
            key: 'crctype',
            type: 'number',
            tooltip: '',
            protocol_id: [0],
            required: true,
            model: this.crctype
        },
        {
            label: 'AddrFilterType',
            key: 'addrfiltertype',
            tooltip: '',
            type: 'select',
            options: this.addrFilterTypeOptions,
            trackBy: 'id',
            value: 'value',
            noOptionsText: '',
            protocol_id: [1],
            required: true,
            model: ''
        },
        {
            label: 'P2CAN',
            key: 'p2can',
            tooltip: '',
            type: 'number',
            protocol_id: [1],
            required: true,
            model: this.p2can
        },
        {
            label: 'P3max',
            key: 'p3max',
            type: 'number',
            tooltip: '',
            protocol_id: [0, 1],
            required: true,
            model: this.p3max
        },
        {
            label: 'TargetAddrType',
            key: 'tatype',
            tooltip: '',
            type: 'select',
            options: this.targetAddrTypeOptions,
            trackBy: 'id',
            value: 'value',
            noOptionsText: '',
            protocol_id: [0, 1],
            required: true,
            model: ''
        },
        {
            label: 'FrameSize',
            key: 'framesize',
            tooltip: '',
            type: 'number',
            protocol_id: [1],
            required: true,
            model: this.framesize
        },
        {
            label: 'NBrMin',
            key: 'nbrmin',
            tooltip: '',
            type: 'number',
            protocol_id: [1],
            required: true,
            model: this.nbrmin
        },
        {
            label: 'NBsMax',
            key: 'nbsmax',
            tooltip: '',
            type: 'number',
            protocol_id: [1],
            required: true,
            model: this.nbsmax
        },
        {
            label: 'NCrMax',
            key: 'ncrmax',
            tooltip: '',
            type: 'number',
            protocol_id: [1],
            required: true,
            model: this.ncrmax
        },
        {
            label: 'NCsMin',
            tooltip: '',
            key: 'ncsmin',
            type: 'number',
            protocol_id: [1],
            required: true,
            model: this.ncsmin
        },
        
        
        {
            label: 'TimeSync',
            key: 'timesync',
            type: 'number',
            tooltip: '',
            protocol_id: [4],
            required: true,
            model: this.timesync
        },
        {
            label: 'TimeIdle',
            key: 'timeidle',
            tooltip: '',
            type: 'number',
            protocol_id: [4],
            required: true,
            model: this.timeidle
        },
        {
            label: 'HeaderType',
            key: 'headertype',
            tooltip: '',
            type: 'select',
            options: this.addrFilterTypeOptions,
            trackBy: 'id',
            value: 'value',
            noOptionsText: '',
            protocol_id: [6],
            required: true,
            model: ''
        },
        {
            label: 'HeaderFilter',
            tooltip: '',
            key: 'headerfilter',
            type: 'number',
            protocol_id: [6],
            required: true,
            model: this.headerfilter
        },
        {
            label: 'HeaderMask',
            tooltip: '',
            key: 'headermask',
            type: 'text',
            maxLength: 50,
            protocol_id: [6],
            required: true,
            model: this.headermask
        },
        {
            label: 'IdPosition',
            key: 'idposition',
            tooltip: '',
            type: 'number',
            protocol_id: [6],
            required: true,
            model: this.idposition
        },
        {
            label: 'IdLength',
            key: 'idlenght',
            tooltip: '',
            type: 'number',
            protocol_id: [6],
            required: true,
            model: this.idlenght
        },
        {
            label: 'RequestTimeOut',
            tooltip: '',
            key: 'requesttimeout',
            type: 'number',
            protocol_id: [2, 6],
            required: true,
            model: this.requesttimeout
        },
        {
            label: 'KeepAliveTimeOut',
            key: 'keepalivetimeout',
            tooltip: '',
            type: 'number',
            protocol_id: [6],
            required: true,
            model: this.keepalivetimeout
        },
        {
            label: 'PhaseSeg1',
            tooltip: '',
            key: 'phaseseg1',
            type: 'number',
            protocol_id: [1, 2, 6],
            required: true,
            rules: numberIsGreaterThanZero,
            model: this.phaseseg1
        },
        {
            label: 'PhaseSeg2',
            key: 'phaseseg2',
            tooltip: '',
            type: 'number',
            protocol_id: [1, 2, 6],
            required: true,
            rules: numberIsGreaterThanZero,
            model: this.phaseseg2
        },
        {
            label: 'PropSeg',
            tooltip: '',
            key: 'propseg',
            type: 'number',
            protocol_id: [1, 2, 6],
            required: true,
            rules: numberIsGreaterThanZero,
            model: this.propseg
        },
        {
            label: 'SJW',
            key: 'sjw',
            type: 'number',
            tooltip: '',
            protocol_id: [1, 2, 6],
            required: true,
            rules: numberIsGreaterThanZero,
            model: this.sjw
        },
        {
            label: 'Sample3Times',
            key: 'sample3times',
            tooltip: '',
            type: 'select',
            options: this.booleanOptions,
            trackBy: 'value',
            value: 'description',
            noOptionsText: '',
            protocol_id: [1, 2, 6],
            required: true,
            model: this.sample3times
        },
        {
            label: 'AddrFilter',
            tooltip: '',
            key: 'addrfilter',
            hexa: true,
            type: 'text',
            maxLength: 50,
            protocol_id: [1],
            required: true,
            model: this.addrfilter
        },
        {
            label: 'AddrMask',
            key: 'addrmask',
            hexa: true,
            tooltip: '',
            type: 'text',
            maxLength: 50,
            protocol_id: [1],
            required: true,
            model: this.addrmask
        }
    ];

    //Breadcrums
    breadcrumsItems: any = [];
    modifySessionFrameData: object = {};
    sortedColumnsByProtocol: object = {
        [ProtocolIds.ISO15765]: ['tatype','addrformat','p2can','p2canextended','p3max','framesize','nbrmin','nbsmax','ncrmax','nbrmin','nbsmax','ncrmax','ncsmin','phaseseg1','phaseseg2','propseg','sjw','sample3times','addrfiltertype','addrfilter','addrmask'],
        [ProtocolIds.CAN]: ['headertype', 'headerfilter', 'headermask', 'idposition', 'idlenght', 'requesttimeout', 'keepalivetimeout', 'phaseseg1', 'phaseseg2', 'propseg', 'sjw', 'sample3times', 'addrfilter', 'addrmask'],
    }

    //methods
    mounted() {
        this.visibleModalCreateProtocol = this.visible;

        EventBus.$on(TypeEventBus.NORMS_ECU_DIALOG_CLOSE_CHILDREN_COMPONENTS, () => {
            this.closeModal();
        });

        EventBus.$on(TypeEventBus.NORMS_ECU_DIALOG_VISIBLE, () => {
            this.closeModal();
        });

        this.assignComboboxOptions();

        if (this.editing) {
            this.submitButtonText = 'Modificar protocolo';
            this.modalTitle = 'Modificar protocolo' + ' <b> - ' + this.patchData['description'] + '</b>';
            this.loadPatchData();
        }
    }

    assignComboboxOptions(){
        //get fields options from norms properties
        let targetAddrTypeOptionsParsed = convertDictionaryToList(this.$_getNormsProperties['all_ecu_target_address_types']);
        let addrFormatOptionsParsed = convertDictionaryToList(this.$_getNormsProperties['all_ecu_address_formats']);
        let addrFilterTypeOptionsParsed = convertDictionaryToList(this.$_getNormsProperties['all_ecu_filter_types']);

        this.targetAddrTypeOptions = targetAddrTypeOptionsParsed;
        this.addrFormatOptions = addrFormatOptionsParsed;
        this.addrFilterTypeOptions = addrFilterTypeOptionsParsed;
        this.headerTypeOptions = this.addrFilterTypeOptions;

        //set options in fields dictionary
        let indexTargetAddrTypeInFields = getIndexFromList(this.fields, 'key', 'tatype');
        let indexAddrFormatInFields = getIndexFromList(this.fields, 'key', 'addrformat');
        let indexAddrFilterTypeInFields = getIndexFromList(this.fields, 'key', 'addrfiltertype');
        let indexHeaderTypeOptions = getIndexFromList(this.fields, 'key', 'headertype');
        let indexMsgValidationType = getIndexFromList(this.fields, 'key', 'msgvalidationtype');
        let indexMsgDetectionType = getIndexFromList(this.fields, 'key', 'msgdetectiontype');

        this.fields[indexTargetAddrTypeInFields]['options'] = targetAddrTypeOptionsParsed;
        this.fields[indexAddrFormatInFields]['options'] = addrFormatOptionsParsed;
        this.fields[indexAddrFilterTypeInFields]['options'] = addrFilterTypeOptionsParsed;
        this.fields[indexHeaderTypeOptions]['options'] = addrFilterTypeOptionsParsed;
        this.fields[indexMsgValidationType]['options'] = this.rxMsgValidationTypeOptions;
        this.fields[indexMsgDetectionType]['options'] = this.rxMsgDetectionTypeOptions;
    }

    assignComboboxDefaultValues(){
        //set default values when creating protocol
        if(!this.editing){
            this.setAddrFormatValue(0);
            this.setHeaderTypeValue(0);
            this.setAddrFilterTypeValue(1);
            this.setTargetAddrTypeValue(1);  
        }
    }

    setAddrFormatValue(optionValue: number){
        let indexFieldInList = getIndexFromList(this.dynamicFormFields, 'key', 'addrformat');
        if(indexFieldInList > -1){
            let valueIndex = this.dynamicFormFields[indexFieldInList]['options'].findIndex(option => option['id'] == optionValue);
            this.dynamicFormFields[indexFieldInList]['model'] = this.dynamicFormFields[indexFieldInList]['options'][valueIndex];
        }
        
    }
    setHeaderTypeValue(optionValue: number){
        let indexFieldInList = getIndexFromList(this.dynamicFormFields, 'key', 'headertype');
        if(indexFieldInList > -1){
            let valueIndex = this.dynamicFormFields[indexFieldInList]['options'].findIndex(option => option['id'] == optionValue);
            this.dynamicFormFields[indexFieldInList]['model'] = this.dynamicFormFields[indexFieldInList]['options'][valueIndex];
        }
        
    }


    setAddrFilterTypeValue(optionValue: number){
        let indexFieldInList = getIndexFromList(this.dynamicFormFields, 'key', 'addrfiltertype');
        if(indexFieldInList > -1){
            let valueIndex = this.dynamicFormFields[indexFieldInList]['options'].findIndex(option => option['id'] == optionValue);
            let optionToSelect = this.dynamicFormFields[indexFieldInList]['options'][valueIndex];
            this.dynamicFormFields[indexFieldInList]['model'] = optionToSelect;
        }
        
    }
    setTargetAddrTypeValue(optionValue: number){
        let indexFieldInList = getIndexFromList(this.dynamicFormFields, 'key', 'tatype');
        if(indexFieldInList > -1){
            let valueIndex = this.dynamicFormFields[indexFieldInList]['options'].findIndex(option => option['id'] == optionValue);
            let optionToSelect = this.dynamicFormFields[indexFieldInList]['options'][valueIndex];
            this.dynamicFormFields[indexFieldInList]['model'] = optionToSelect;
        }
    }


    updateFormModel(value, index){
        this.dynamicFormFields[index]['model'] = value
    }

    updateBaudRate(value){
        this.baudrate = value;
    }

    updateProtocolDescription(value){
        this.protocolDescription = value;
    }

    getIndexId(list, id){
        return getIndexFromList(list, 'id', id);
    }

    loadPatchData() {
        for (let index = 0; index < this.fields.length; index++) {
            let formField = this.fields[index];

            let fieldsToPatchKeys = Object.keys(this.patchData);

            this.protocolDescription = this.patchData['description'];
            this.baudrate = this.patchData['baudrate'];
            let protocolId = this.patchData['type'];
            let indexOfProtocolId= this.getIndexId(this.protocolTypes, protocolId);

            this.updateProtocolType(this.protocolTypes[indexOfProtocolId]);

            //recorro las claves que llegan en el patch
            for (let b = 0; b < fieldsToPatchKeys.length; b++) {
                const field = fieldsToPatchKeys[b];

                if (formField['key'] === field) {
                    if (formField['type'] === 'select') {
                        formField['model'] = this.getValueForSelect(formField, field)
                    } else {
                        formField['model'] = this.patchData[field];
                    }
                }
            }
        }
    }

    getValueForSelect(formField: object, field: string): object{
        let fieldKey = formField['key'];
        let selectorNumValue = this.patchData[field].toString();
        let fieldKeyID = formField['trackBy'];
        let fieldKeyText = formField['value'];
        let selectValue:any = {
            [fieldKeyID]: selectorNumValue,
            [fieldKeyText]: this.patchData[field]
        };

        const optionsMap = {
            msgdetectiontype: this.rxMsgDetectionTypeOptions,
            msgvalidationtype: this.rxMsgValidationTypeOptions,
            tatype: this.targetAddrTypeOptions,
            addrfiltertype: this.addrFilterTypeOptions,
            headertype: this.headerTypeOptions,
            addrformat: this.addrFormatOptions
        };

        if (optionsMap[fieldKey]) {
            let index = getIndexFromList(optionsMap[fieldKey], fieldKeyID, selectorNumValue);
            if (index !== -1) {
                selectValue = optionsMap[fieldKey][index];
            }
        }else{
            let index = this.booleanOptions.findIndex(option => option[fieldKeyID] == this.patchData[field]);
            if(index !== -1){
                selectValue = this.booleanOptions[index]
            }
        }

        return selectValue
    }

    assignInitialization() {
        let initId = this.patchData['initialization']['id'];
        let initIndex = this.getIndexId(this.initializationsOptions, initId);
        this.initializationSelected = this.initializationsOptions[initIndex];
    }

    assignFinalization() {
        let finId = this.patchData['finalization']['id'];
        let finIndex = this.getIndexId(this.finalizationsOptions, finId);
        this.finalizationSelected = this.finalizationsOptions[finIndex];
    }

    visibilityModalCreateSessionFrame(value) {
        this.visibleModalCreateSessionFrame = value;
    }

    createNewInitOrFinalization(action) {
        this.actionModalInitOrFin = action;
        this.visibilityModalCreateSessionFrame(true);
    }

    modifySessionFrame(action) {
        if (action === 'Inicialización') {
            this.loadingModifyInicialization = true;
            let initType = this.initializationSelected['type'].replace(/['"]+/g, '').toLowerCase();
            let initId = Number(this.initializationSelected['id']);
            let protocolType = Number(this.protocolType['id']);
            let self = this;
            NormsServices.getProtocolInitializationDetail(initType, protocolType, initId)
                .then(response => {
                    this.actionModalInitOrFin = action;
                    this.loadingModifyInicialization = false;
                    this.editSessionFrame = true;
                    if(response['framearray'] === '{}'){
                        response['framearray'] = ''
                    }
                    this.modifySessionFrameData = response;
                    this.visibilityModalCreateSessionFrame(true);
                })
                .catch(error => {
                    // console.log("error", error);
                    this.loadingModifyInicialization = false;
                    self.handleErrorAction(error, 'No se pudo traer la inicialización del protocolo');
                });
        } else {
            //finalizacion
            this.loadingModifyFinalization = true;
            let sessionFrameId = Number(this.finalizationSelected['id']);
            let self = this;
            // let protocolType = Number(this.protocolType['id']);
            NormsServices.getSessionFrameById(sessionFrameId)
                .then(response => {
                    this.actionModalInitOrFin = action;
                    this.loadingModifyFinalization = false;
                    this.editSessionFrame = true;
                    if(response['framearray'] === '{}'){
                        response['framearray'] = ''
                    }
                    this.modifySessionFrameData = response;
                    this.visibilityModalCreateSessionFrame(true);
                })
                .catch(error => {
                    // console.log("error", error);
                    this.loadingModifyFinalization = false;
                    self.handleErrorAction(error, 'No se pudo obtener la session frame');
                });
        }
    }

    submitAction() {
        if (!this.editing) {
            this.generateProtocol();
        } else {
            this.patchProtocol();
        }
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    patchProtocol() {
        let self = this;
        self.pendingLoadingDialog('Modificando protocolo...')
        self.scrollToTopOfModal();
        self.pendingGenerateProtocol(true);
        let configuration = this.getPostConfiguration();
        let protId = this.patchData['id'];
        NormsServices.patchProtocol(configuration, protId)
            .then(response => {
                // console.log("protocolo creado", response);
                self.successPost = true;
                self.handleSuccessAction(response.data, 'Protocolo actualizado correctamente');
                self.closeModal();
                self.$emit('update-protocol', response['data']['updated_protocol']);
            })
            .catch(error => {
                // console.log("error protocolo", error);
                self.handleErrorAction(error, 'No se pudo modificar el protocolo');
            }).finally(() => {
                self.pendingGenerateProtocol(false);
            })
    }

    generateProtocol() {
        let self = this;
        self.pendingLoadingDialog('Generando protocolo...')
        self.scrollToTopOfModal();
        self.pendingGenerateProtocol(true);
        let configuration = this.getPostConfiguration();
        NormsServices.postCreateProtocol(configuration)
            .then(response => {
                // console.log("protocolo creado", response);
                self.successPost = true;
                self.handleSuccessAction(response, 'Protocolo creado correctamente');
                self.closeModal();
                self.$emit('add-new-protocol', response['new_protocol']);
            })
            .catch(error => {
                // console.log("error protocolo", error);
                self.handleErrorAction(error, 'No se pudo crear el protocolo');
            }).finally(() => {
                self.pendingGenerateProtocol(false);
            })
    }

    scrollToTopOfModal() {
        $('.dialog-scroll').scrollTop(0);
    }

    pendingGenerateProtocol(value) {
        this.pendingRequest = value;
    }

    @Watch('dynamicFormFields', { deep: true })
    watchFormFields(fields) {
        let self = this;
        let counter = 0;
        for (let i = 0; i < fields.length; i++) {
            const field = fields[i]['model'];
            if (field == null || field === '') {
                counter++;
            }
        }

        self.existsEmptyFields = counter;
    }

    @Watch('protocolType')
    updateProtocolSelected(protocolSelected) {
        let protocolId = protocolSelected['id'];

        if (protocolSelected !== null) {
            this.getProtocolInitializations(protocolId);
            this.getFinalizationOptions(protocolId);
            this.updateFormFields(Number(protocolId));
        } else {
            this.updateFormFields(-1);
        }
    }

    updateFormFields(protocolId) {
        if (protocolId == -1) {
            this.dynamicFormFields = this.getFieldsSortedByProtocolId(this.fields, protocolId);
        } else {
            let filteredFields = this.fields.filter(item => item['protocol_id'].indexOf(protocolId) !== -1);
            this.dynamicFormFields = this.getFieldsSortedByProtocolId(filteredFields, protocolId);
            this.assignComboboxDefaultValues();
        }
    }

    getFieldsSortedByProtocolId(fields, protocolId) {
        if(!this.sortedColumnsByProtocol[protocolId]){
            return fields
        }
        
        fields = fields.sort((a, b) => {
            return this.sortedColumnsByProtocol[protocolId].indexOf(a.key) - this.sortedColumnsByProtocol[protocolId].indexOf(b.key);
        });
        return fields
        
    }

    updateInitializationSelected(option) {
        this.initializationSelected = option;
    }

    updateInitializationResetValue(value) {
        this.resetInitializationSelect = value;
    }

    resetInitializationSelected() {
        this.updateInitializationSelected(null);
        this.updateInitializationResetValue(true);
    }

    updateFinalizationSelected(option) {
        this.finalizationSelected = option;
    }

    updateFinalizationResetValue(value) {
        this.resetFinalizationSelect = value;
    }

    resetFinalizationSelected() {
        this.updateFinalizationSelected(null);
        this.updateFinalizationResetValue(true);
    }

    resetCombobox(idx) {
        this.fields[idx]['model'] = null;
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.visibilityCloseConfirmationModal(false);
    }

    showCloseConfirmationModal() {
        this.visibilityCloseConfirmationModal(true);
    }

    visibilityCloseConfirmationModal(value) {
        this.visibleCloseConfirmationModal = value;
    }

    closeModalCreateSessionFrame() {
        this.editSessionFrame = false;
        this.visibilityModalCreateSessionFrame(false);
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    getPostConfiguration() {
        let protocolId = Number(this.protocolType['id']);
        let protocolName = this.protocolType['value'];
        let data = {
            protocol_type: protocolId,
            description: this.protocolDescription,
            baudrate: this.baudrate
        };
        protocolName = this.protocolType['value'].toLowerCase();
        data[protocolName] = {};
        this.$set(data, 'finalization', this.getFinalizationValue(this.finalizationSelected));
        this.$set(data, 'initialization', this.getInitializationValue(this.initializationSelected));

        for (let i = 0; i < this.dynamicFormFields.length; i++) {
            const field = this.dynamicFormFields[i];
            let value = field['model'];

            if (field['type'] === 'select') {
                let valueId = field['trackBy'];
                value = field['model'][valueId];
            }

            if(isNumber(value)){
                value = Number(value);
            }

            this.$set(data[protocolName], field['key'], value);
        }
        return data;
    }

    get getProtocolSelected() {
        return this.protocolType !== null ? this.protocolType : '';
    }

    get disableCreateInitAndFin() {
        if (this.getProtocolSelected['value'] === 'Scanner') {
            return true;
        } else {
            return false;
        }
    }

    get disableEditInitialization() {
        if (this.initializationSelected !== null && this.initializationSelected['id'] == -1) {
            return true;
        } else {
            return false;
        }
    }

    get disableEditFinalization() {
        if (this.finalizationSelected !== null && this.finalizationSelected['id'] == -1) {
            return true;
        } else {
            return false;
        }
    }

    get getBreadcrumsItems() {
        return [
            {
                text: 'Listado de ECUs',
                disabled: false,
                href: '',
                active: false,
                action: 'goToEcuList'
            },
            {
                text: !this.editingEcu ? 'Crear Ecu' : 'Modificar ECU',
                disabled: false,
                href: '',
                active: false,
                action: 'back'
            },
            {
                text: this.editing ? 'Modificar Protocolo' : 'Crear Protocolo',
                disabled: false,
                href: '',
                active: true,
                action: null
            }
        ];
    }

    // createNewFinitialization(){
    //     this.visibilityModalCreateInitialization(true);
    // }

    getFinalizationValue(finalization) {
        if (finalization !== null) {
            if (finalization['id'] !== -1) {
                return finalization['id'];
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    getInitializationValue(initialization) {
        if (initialization !== null) {
            if (initialization['id'] !== -1) {
                return initialization;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    getProtocolInitializations(protocolId) {
        let self = this;
        self.resetInitializationSelected();
        this.pendingProtocolInitializations = true;
        NormsServices.getProtocolsInitializations(protocolId)
            .then(response => {
                self.initializationsOptions = response['initializations'];
                if (self.editing) {
                    self.assignInitialization();
                } else {
                    if (self.initializationsOptions.length == 1) {
                        if (self.initializationsOptions[0]['id'] == -1) {
                            this.updateInitializationSelected(self.initializationsOptions[0]);
                        }
                    }
                }
                this.pendingProtocolInitializations = false;
            })
            .catch(error => {
                // console.log("error", error);
                this.pendingProtocolInitializations = false;
                self.handleErrorAction(error, 'No se pudieron traer las inicializaciones del protocolo');
            });
    }

    getFinalizationOptions(protocolId) {
        let self = this;
        self.resetFinalizationSelected();
        this.pendingProtocolFinalizations = true;
        NormsServices.getSessionFramesList(protocolId)
            .then(response => {
                self.finalizationsOptions = response['session_frames'];
                if (self.editing) {
                    self.assignFinalization();
                } else {
                    if (self.finalizationsOptions.length == 1) {
                        if (self.finalizationsOptions[0]['id'] == -1) {
                            this.updateFinalizationSelected(self.finalizationsOptions[0]);
                        }
                    }
                }

                self.pendingProtocolFinalizations = false;
            })
            .catch(error => {
                self.pendingProtocolFinalizations = false;
                self.handleErrorAction(error, 'No se pudo traer la lista de session frames');
            });
    }


    updateProtocolType(option) {
        this.protocolType = option;
    }

    addNewInitialization(newInit) {
        this.pendingProtocolInitializations = true;
        let newInitialization = {
            description: newInit['description'],
            id: newInit['id'],
            type: newInit['type']
        };
        this.initializationsOptions.push(newInitialization);
        this.initializationSelected = newInitialization;
        setTimeout(() => {
            this.pendingProtocolInitializations = false;
        }, 200);
    }

    addNewFinalization(newFin) {
        this.pendingProtocolFinalizations = true;
        let newFinalization = {
            description: newFin['description'],
            id: newFin['id']
        };
        this.finalizationsOptions.push(newFinalization);
        this.finalizationSelected = newFinalization;
        setTimeout(() => {
            this.pendingProtocolFinalizations = false;
        }, 200);
    }

    updateInitialization(newInit) {
        let indexIdToPatch = this.getIndexId(this.initializationsOptions, newInit['id']);
        this.$set(this.initializationsOptions[indexIdToPatch], 'description', newInit['description']);
        this.$set(this.initializationsOptions[indexIdToPatch], 'id', newInit['id']);
        this.$set(this.initializationsOptions[indexIdToPatch], 'type', newInit['type']);
        this.initializationSelected = this.initializationsOptions[indexIdToPatch];
    }

    updateFinalization(newFin) {
        let indexIdToPatch = this.getIndexId(this.finalizationsOptions, newFin['id']);
        this.$set(this.finalizationsOptions[indexIdToPatch], 'description', newFin['description']);
        this.$set(this.finalizationsOptions[indexIdToPatch], 'id', newFin['id']);
        this.$set(this.finalizationsOptions[indexIdToPatch], 'type', newFin['type']);
        this.finalizationSelected = this.finalizationsOptions[indexIdToPatch];
    }

    checkRequiredFields() {
        let invalidRequiredFields = 0;
        for (let index = 0; index < this.dynamicFormFields.length; index++) {
            const dynamicField = this.dynamicFormFields[index];

            let fieldHasRules = dynamicField.hasOwnProperty('rules');
            if(fieldHasRules){
                let fieldRules = dynamicField['rules'];
                let valueIsValid = fieldRules(dynamicField['model']) == true;
                if(!valueIsValid){
                    invalidRequiredFields++;
                }
            }
        }
        return invalidRequiredFields > 0
    }

    get checkIfFormIsValid() {
        if (
            //validate base fields
            this.baudrate !== '' &&
            this.protocolDescription !== '' &&
            this.protocolType !== null
        ) {
            if (this.protocolType['id'] !== this.idScannerProtocol.toString()) {
                //validate dynamic fields
                let thereAreEmptyDynamicFields = this.existsEmptyFields > 0;
                let areInvalidRequiredFields = this.checkRequiredFields();

                return !thereAreEmptyDynamicFields && !areInvalidRequiredFields;
                
            } else {
                return true;
            }
        } else {
            return false;
        }
    }
}
